import { Button, ButtonProps } from 'antd';
import { cx } from '@emotion/css';

interface DefaultButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export const DefaultButton = (props: DefaultButtonProps) => {
  const { children, className, ...restProps } = props;

  return (
    <Button
      className={cx('!bg-[#ECECED] !border-none !text-[#515359] hover:opacity-80', className)}
      {...restProps}
    >
      {children}
    </Button>
  );
};
